import Switch from "../../../../components/Switch";
import { cardIsActivated } from "../../../../helpers/debitcard";
import { DebitCardStatusEnum, QueryAccountResponse } from "../../../../types";
import { SettingsItem } from "../Settings/components";
import { ReactComponent as ArrowRight } from "../../../../assets/fullarrowright.svg";
import useSetDebitCardStatus from "../../../../hooks/mutations/employee/useSetDebitCardStatus";
import { useNavigate } from "react-router-dom";
import {
  employeeDebitCardChangeAddressPath,
  employeeDebitCardChangePinPath,
  employeeDebitCardOrderNewPath,
} from "../../../../routes/paths";

export const DebitCardEnabledSetting = ({
  data,
}: {
  data: QueryAccountResponse["challenger_saving"]["debit_card"];
}) => {
  const { mutate: updateStatus, status } = useSetDebitCardStatus();
  const isActivated = cardIsActivated(data);

  if (isActivated) {
    const isStatusActive =
      data.latest_card.tp_status === DebitCardStatusEnum.active;
    return (
      <SettingsItem
        title="Debit Card Enabled"
        subtitle="Can be turned on or off at any time"
        rightSide={
          <Switch
            checked={isStatusActive}
            disabled={status === "loading"}
            onClick={() =>
              updateStatus({
                cardId: data.latest_card_id,
                status: isStatusActive
                  ? DebitCardStatusEnum.suspended
                  : DebitCardStatusEnum.active,
              })
            }
          />
        }
      />
    );
  }
  return null;
};

export const OrderNewCardSetting = () => {
  const navigate = useNavigate();
  return (
    <SettingsItem
      title="Order a New Card"
      subtitle="Lost card? Request a new card."
      rightSide={<ArrowRight />}
      handleOnClick={() => navigate(employeeDebitCardOrderNewPath)}
    />
  );
};

export const ChangePinSetting = ({
  data,
}: {
  data: QueryAccountResponse["challenger_saving"]["debit_card"];
}) => {
  const navigate = useNavigate();
  const isActivated = cardIsActivated(data);
  if (isActivated) {
    return (
      <SettingsItem
        title="Change Your PIN"
        rightSide={<ArrowRight />}
        handleOnClick={() => navigate(employeeDebitCardChangePinPath)}
      />
    );
  }
  return null;
};

export const ChangeAddressSetting = () => {
  const navigate = useNavigate();
  return (
    <SettingsItem
      title="Change Your Address"
      rightSide={<ArrowRight />}
      handleOnClick={() => navigate(employeeDebitCardChangeAddressPath)}
      showBottomBottomBorder={false}
    />
  );
};
